
import $ from "jquery";
import { dialog } from "../../../components/dialog";

const loader = (() => {
    // const LOADER_ELEMENT = '.js-loader';
    const DOM_POPIN = 'popin-loading'
    // const LOADER_ELEMENT_HTML = '<div class="loader"></div>';
    // const loaderElementsInit = () => {
    //     $(LOADER_ELEMENT).each(function () {
    //         $(this).append(LOADER_ELEMENT_HTML);
    //     });
    // };
    const init = () => {
        // loaderElementsInit();
        document.addEventListener('LOADER', (event) => {
            // $(LOADER_ELEMENT).toggleClass('loading');
            // $(DOM_POPIN).toggleClass('active')
            if (event.detail && event.detail.show !== undefined) {
                (event.detail.show)? dialog.open(DOM_POPIN):dialog.close(DOM_POPIN);
            } else if (dialog.get(DOM_POPIN).getAttribute('aria-hidden') === 'true') {
                dialog.open(DOM_POPIN);
            } else {
                dialog.close(DOM_POPIN);
            }
        });
    };
    return {init}
})();
export default loader;
